import txBuilder from "./txBuilder";

export default (projectName) => {
  return {
    txBuilder: txBuilder(projectName),
  };
};
